import {
  isBooleanFieldType,
  isDateFieldType,
  isFloatFieldType,
  isIntegerFieldType,
  isNumberFieldType,
  isStringFieldType,
} from 'modules/domains/segmentation/utils';
import { useConditionFieldNameWatch } from '../../../../hooks/form';
import { useHasConditionFieldName } from '../../../../hooks/useHasConditionFieldName';
import { useFields } from '../../hooks/useFields';

export const useConditionValueInputType = () => {
  const fields = useFields();
  const fieldName = useConditionFieldNameWatch();
  const searchedField = fields.find(
    ({ fieldName: searchFieldName }) => fieldName === searchFieldName,
  );
  const hasFieldName = useHasConditionFieldName();

  const isStringInput = hasFieldName && isStringFieldType(searchedField?.fieldType);
  const isNumberInput = hasFieldName && isNumberFieldType(searchedField?.fieldType);
  const isIntegerInput = hasFieldName && isIntegerFieldType(searchedField?.fieldType);
  const isFloatInput = hasFieldName && isFloatFieldType(searchedField?.fieldType);
  const isBooleanSelect = hasFieldName && isBooleanFieldType(searchedField?.fieldType);
  const isDateSelect = hasFieldName && isDateFieldType(searchedField?.fieldType);

  return {
    isStringInput,
    isNumberInput,
    isIntegerInput,
    isFloatInput,
    isBooleanSelect,
    isDateSelect,
  };
};
